var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticStyle: { "max-width": "100vw" }, attrs: { id: "sekce-medicom" } },
      [
        _c("div", { staticClass: "medicom-bg" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("img", {
            staticClass: "medicom-imtro-img",
            attrs: { src: "/theme/images/klienti/medicom.jpg", alt: "" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { ref: "caruselContainer", staticClass: "carusel-container" },
            [
              _c(
                "div",
                { staticClass: "carusel-wrapper" },
                _vm._l(_vm.caruselItems, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "carusel-item" },
                    [
                      _c("img", { attrs: { src: item.src, alt: "" } }),
                      _vm._v(" "),
                      _vm._m(1, true)
                    ]
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "carusel-bottom-space" })
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "medicom-heading" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "medicom-heading" }, [
          _c("h2", [_vm._v("MEDIOM CLINIC")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "carusel-item-text-wrapper" }, [
      _c("h3", [_vm._v("Krásnější díky plastice")]),
      _vm._v(" "),
      _c("p", { staticClass: "typ" }, [_vm._v("Web")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }